// extracted by mini-css-extract-plugin
export default {"parkingZoneBorder":"index_parkingZoneBorder__3NUVQ"};